/**
 * Simple form state tracking, to enable/disable submit button.
 * @type {Map<any, any>}
 */
const FORM_STATES = new Map();

function serializeFormData(formElement) {
  let formData = new FormData(formElement);
  let data = Array.from(formData.entries())
      .map(([key, value]) => {
        if (value instanceof File) {
          // For files, capture unique metadata instead of full binary content
          return [key, `file:${value.name}:${value.size}:${value.lastModified}`];
        } else {
          return [key, String(value)];
        }
      })
      .sort((a, b) => a[0].localeCompare(b[0]));
  return JSON.stringify(data);
}

function watchForm(formElement) {
  let hasChanged;
  if (!FORM_STATES.has(formElement)) {
    FORM_STATES.set(formElement, serializeFormData(formElement));
    hasChanged = false;
  } else {
    hasChanged = serializeFormData(formElement) !== FORM_STATES.get(formElement);
  }
  formElement.querySelectorAll("[type=submit]").forEach((button) => {
    button[(hasChanged) ? "removeAttribute" : "setAttribute"]("disabled", true);
  });
}

function startSync(formElement) {
  watchForm(formElement);
  formElement.addEventListener("input", () => watchForm(formElement));
}

export {
  startSync
}
